<div class="table-filters">
    <div class="filter-button" (click)="openFilterMenu()">
        <app-custom-icon
            [iconPath]="'assets/icons/general-icons.svg'"
            [imageName]="'filter'"
            [imageSize]="'18'">
        </app-custom-icon>
        <span>Filter</span>
    </div>
    <app-topbar-filter-button
        [filter]="dateRangeChip"
        [closeActive]="false"
        [dataToDisplay]="
            currentFilters?.createdAt?.length
                ? (currentFilters.createdAt | dateIntervalToString)
                : 'All Time'
        "></app-topbar-filter-button>

    @for (filter of currentFilters | keyvalue; track filter.key) {
        @if (filter.value?.length) {
            @switch (filter.key) {
                @case ("individual") {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="
                            'Individual: ' +
                            (filter.value | findInList: userList)?.label
                        "
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
                @case ("groups") {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="
                            filter.value
                                | filterChipLabel: groupFilterOptions?.all : 'Group'
                        "
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
            }
        }
    }
</div>
